import React, { useState, useEffect } from 'react'; 

import SupplierModal from './SupplierModal';
import classes from './SupplierMasterPage.module.css';
import CONSTANTS from '../../../../_constants/constants';
import { ApiService } from '../../../../_services/api.service';

import Alert from '../../../UI/Alert/Alert';
import Button from '../../../UI/Button/Button';
import Loader from '../../../UI/Loader/Loader';
import SearchBar from '../../../UI/SearchBar/SearchBar';
import Table from '../../../UI/Table/Table';
import PageLayout from '../../../Layout/PageLayout/PageLayout';

const SupplierMasterPage = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [gridData, setGridData] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalName, setModalName] = useState('');
    const [modalData, setModalData] = useState({});
    const [filterKeyword, setFilterKeyword] = useState('');
    
    const tableHeaders = ['Supplier'];
    const dataFields = ['supplierName'];
    const tableConfig = {
        headerAlignConfig: {
            'Supplier': 'left'
        },
        widthConfig: {
            'Supplier': 'auto'
        },
        alignConfig: {
            'supplierName': 'left'
        }
    }
    
    useEffect(() => {
        getSupplierData();
    }, []);
    
    const modalCloseHandler = status => {
        setModalIsOpen(false);
        if(status === 'save') {
            getSupplierData();
        }
    }

    const getSupplierData = () => {
        const url = `${CONSTANTS.API_URL}Supplier/AllSupplier`;
        ApiService.getData(url).then(
            result => {
                if(result.data) {
                    setIsLoading(false);
                    setGridData(result.data.results);
                    setPageCount(Math.ceil(result.data.results.length/10));
                } else {
                    setIsLoading(false);
                    setErrorMessage(result.error.message);
                }
            },
            error => {
                setIsLoading(false);
                setErrorMessage(error);
            }
        );
    }

    const modalOpenHandler = (modalName, modalData) => {
        setModalIsOpen(true);
        setModalName(modalName);
        modalData === '' ? setModalData({}) : setModalData(modalData);
    }
    
    const handleAfterOpen = (event, data) => console.log(event, data)

    const filterKeywordChangeHandler = event => setFilterKeyword(event.target.value);

    const filterDataHandler = filteredData => {
        return filteredData.filter( data =>
            data.supplierName && data.supplierName.toLowerCase().includes(filterKeyword.toLowerCase())
        )
    }

    return (
        <>
            { isLoading && <Loader /> }
            { !isLoading && (
                <PageLayout pageTitle='Supplier Master'>
                    <div className='row mb-3'>
                        <div className={`col-12 ${classes.headerActions}`}>
                            <SearchBar onFilterKeywordChange={filterKeywordChangeHandler} />
                            <div>
                                <Button btnClass='btn btn-primary' onClick={e => modalOpenHandler('Add', '')} btnText='Add Supplier' btnTitle='Add Supplier' btnType='Add' />
                                <SupplierModal
                                    modalData={modalData}
                                    modalName={modalName}
                                    isModalOpened={modalIsOpen}
                                    onCloseModal={modalCloseHandler}
                                    onAfterOpen={handleAfterOpen}
                                />
                            </div>
                        </div>
                    </div>
                    { errorMessage && <Alert alertClassName='danger' message={errorMessage} /> }
                    <Table 
                        tableHeaders={tableHeaders} 
                        dataFields={dataFields} 
                        tableConfig={tableConfig}
                        pageCount={pageCount} 
                        onModalOpen={modalOpenHandler} 
                        sort={true}
                        actions={true}
                        edit={true} 
                        delete={true} 
                        filter={true}
                        status={true}
                        paginate={false}
                        rowClick={false}
                        gridData={gridData}
                        filterKeyword={filterKeyword}
                        onFilterData={filterDataHandler}
                    />
                </PageLayout>
            )}    
        </>
    );
  
}

export default SupplierMasterPage;